<template>
  <div class="maillistpro">

    <div class="province-box" v-if="contactsList.length > 0 || list.length > 0 ">
      <div class="list-box">
        <div
          class="items-box"
          v-for="(items,idx) in list"
          :key="idx"
          @click="toPersonList(items,idx)"
        >
          <img src="../../assets/index/ic_bm_qz.png" alt class="file-icon" />
          <div class="centertext">{{items.name}}</div>
          <img src="../../assets/index/ic_bm_jt.png" alt class="right-icon" />
        </div>
      </div>
      <div class="other-box">
        <div class="items-box" v-for="(items,idx) in contactsList" :key="idx">
          <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="headimg" />
          <div class="info-box">
            <div class="username">{{items.name}}</div>
            <div class="phone">{{items.mobile}}</div>
          </div>
            <div class="phone-box" @click="sendMessage(items)">
                <van-icon name="chat" color="#36b374" size="15" :dot="!!items.unreadCount" />
            </div>
          <div @click="playPhone(items)">
           <a><img src="../../assets/index/ic_ts_dh.png" alt class="phone-icon" /></a>
          </div>
        </div>
      </div>
    </div>
    <empty :type="3" v-if="contactsList.length === 0 && list.length === 0 && !loading"></empty>
    <callPhone ref="callPhone" :combinPhone="combinPhone" :userInfo="userInfo"></callPhone>
  </div>
</template>

<script>
    import callPhone from 'comps/callPhone';
    import mixin from '@/mixins/index';
    import apis from '../../service/modules/index';
    import empty from 'comps/empty';
    import {
        mapState
    } from 'vuex';
    export default {
        components: {
            callPhone,
            empty
        },
        mixins: [mixin],
        data () {
            return {
                list: [],
                contactsList: [],
                index: 0,
                idx: 0,
                combinPhone: 0,
                loading: false,
                type: 0,
	            userInfo: {}
            };
        },
        computed: {
            ...mapState('home', [
                'contacts',
                'keyword',
                'currentUserInfo'
            ])

        },

        methods: {
            toPersonList (item) {
                this.$router.push(`/provincemaillist?id=${item.id}&title=${encodeURI(item.name)}`)
                // window.yyn.invokeJSB(
                //     'openWindow', {
                //         openUrl: `${this.globalApp.getSystemInfo().host}web/#/provincemaillist?id=${item.id}&title=${encodeURI(item.name)}`,
                //         isFullScreen: 0,
                //         setTitle: item.name,
                //         needLoading: 1
                //     },
                //     cb => {
                //         console.log(cb, 'callback');
                //     }
                // );
            },
            playPhone (item) {
                if (this.type === 1) {
                    let list = [];
                    list.push(item);
                    this.keyword.forEach(element => {
                        if (element.mobile !== item.mobile && list.length < 10) {
                            list.push(element);
                        }
                    });
                    this.$store.dispatch('home/setKeyword', list); // 设置浏览记录
                }
                this.call(item)
                this.combinPhone = Number(item.mobile);
	            this.userInfo = {
		            targetName: item.name,
		            targetId: item.staffCode,
		            userId: this.currentUserInfo.staffCode,
		            name: this.currentUserInfo.name
	            };
                this.$refs.callPhone.showBox();
            },
	        async sendMessage(item) {
		        if (this.currentUserInfo.name) {
			        await apis.importAccount({
				        nick: this.currentUserInfo.name,
				        identifier: `yjg_${this.currentUserInfo.staffCode}`
			        });
		        }
		        if (item.name) {
			        await apis.importAccount({
				        nick: item.name,
				        identifier: `yjg_${item.staffCode}`
			        });
		        }
		        let value = {
			        targetId: item.staffCode,
			        userId: this.currentUserInfo.staffCode
		        };
		        let str = [];
		        for (let key in value) {
			        str.push(key + '=' + value[key]);
		        }
		        let query = str.join('&');
		        if (process.env.NODE_ENV === 'development') {
			        this.$router.push({
				        path: `/personalChat?${query}`
			        })
		        }
		        window.yyn.invokeJSB(
			        'openWindow',
			        {
				        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personalChat?${query}`,
				        isFullScreen: 1,
				        setTitle: '',
				        needLoading: 1
			        },
			        cb => {
				        console.log(cb, 'callback');
			        }
		        );
	        }

        },
        mounted () {
            // let data = JSON.parse(localStorage.getItem('contactsList'))
            this.$store.dispatch('home/loadContacts')
            this.$store.dispatch('home/reLoadKeyword')
            let id = this.$route.query.id||''
            let code=this.$route.query.code||''
            this.type = Number(this.$route.query.type) || 0
            let title = decodeURI(this.$route.query.title)
            window.yyn.invokeJSB(
                'setTitle',
                {
                    title: title
                },
                cb => {

                }
            );
            this.loading = true;
            apis.getAddressbookbyid({ unitId: id ,code:code}).then(res => {
                this.loading = false
                this.list = res.data.units[0].children
                this.contactsList = res.data.units[0].contacts
            })
            // var fn = (data) => {
            //     for (var i = 0; i < data.length; i++) {
            //         if (data[i].name === name) {
            //             this.list = data[i].children
            //             this.contactsList = data[i].contacts
            //             break
            //         }
            //         if (data[i].children && data[i].children.length > 0) {
            //             fn(data[i].children)
            //         }
            //     }
            // }
            // fn(data)
        },

        created () {

        }
    };
</script>

<style scoped lang="less">
.maillistpro {
  width: 100%;
  .back-box {
    height: 44px;
    position: relative;
    box-sizing: border-box;
    padding: 0 12px;
    background: #36b374;

    .text {
      font-size: 16px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
    }
    .back-icon {
      width: 10px;
      height: 16px;
      position: absolute;
      left: 20px;
      top: 14px;
    }
  }
  .province-box {
    box-sizing: border-box;
    padding: 0 12px;
    .other-box {
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      overflow: hidden;
      .items-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        height: 68px;
        box-sizing: border-box;
        padding: 16px 0;
        border-bottom: 1px solid #eeeeee;

        .headimg {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }

        .info-box {
          flex: 1;
          text-align: left;
          .username {
            height: 20px;
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            // line-height: 16px;
            line-height: 20px;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 250px;
          }
          .phone {
            height: 12px;
            font-size: 12px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
          }
        }
        .phone-icon {
          width: 14px;
          height: 16px;
          margin-right: 8px;
        }
      }
    }
    .list-box {
      border-radius: 3px;
      overflow: hidden;
      .items-box {
        height: 67px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 16px 0;
        border-bottom: 1px solid #eee;

        &:last-child {
          border-bottom: none;
        }

        .file-icon {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }

        .centertext {
          font-size: 16px;
          // font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          flex: 1;
          text-align: left;
        }
        .right-icon {
          width: 9px;
          height: 15px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
